import React, { FunctionComponent } from 'react';
import clsx from 'clsx';
import { Grid } from '@material-ui/core';
import SummaryLabelTooltip from './SummaryLabelTooltip';
import summaryLabelStyles from './SummaryLabelStyles';

export interface ISummaryLabelTitleProps {
  label: string | JSX.Element;
  boldLabel?: boolean;
  labelClassNames?: string;
  colSm: any;
  colXs: any;
  isTooltipOpen?: boolean;
  toggleTooltip?: React.Dispatch<React.SetStateAction<boolean>>;
  tooltipText?: string;
}

const SummaryLabelTitle: FunctionComponent<ISummaryLabelTitleProps> = ({
  label,
  boldLabel,
  labelClassNames,
  colSm,
  colXs,
  isTooltipOpen,
  toggleTooltip,
  tooltipText,
}) => {
  const styles = summaryLabelStyles();

  return (
    <Grid
      item={true}
      sm={colSm}
      xs={colXs}
      className={clsx(labelClassNames, styles.label, styles.listText, [{ [styles.boldLabel]: boldLabel }])}
    >
      {label}
      {!!toggleTooltip && (
        <SummaryLabelTooltip toggleTooltip={toggleTooltip} isOpen={isTooltipOpen} text={tooltipText} />
      )}
    </Grid>
  );
};

export default SummaryLabelTitle;
